/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import EditDoctorDataContent from "components/content/EditDoctorDataContent";
import DefaultDashboardLayout from "layouts/dashboard/DefaultDashboardLayout";
import { FC, useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";

/**
 * Nurse profile editing page.
 * Allows modification of existing nurse staff information.
 * 
 * Features:
 * - Edit nurse profile information
 * - Update certifications and credentials
 * - Modify assignments and schedule
 * - Update contact information
 * - Form validation with error handling
 * - Integration with nursing staff management system
 * 
 * The page receives doctorId (reused for nurses) via:
 * - Navigation state from nurses list page, or
 * - URL parameter for direct access
 * 
 * Note: Component named EditDoctorPage but used for nurse editing,
 * shares same data structure and form components.
 * 
 * @returns {JSX.Element} Edit nurse page component
 */
const EditDoctorPage: FC = () => {
  const { state } = useLocation();
  const { doctorId } = state;

  let { id } = useParams();

  const idResult = useMemo<string>(() => doctorId || id, [doctorId, id]);

  console.log(id);

  return (
    <DefaultDashboardLayout>
      <EditDoctorDataContent doctorId={idResult} />
    </DefaultDashboardLayout>
  );
};

export default EditDoctorPage;

